import { withState } from 'recompose';

export default withState('searchData', 'updateSearchData', {
  name: '',
  status: '',
  email: '',
});
